/* eslint-disable react-hooks/exhaustive-deps */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return useModel;
    }
});
const _react = require("react");
const _utilities = require("../../utilities");
const _useColorbar = /*#__PURE__*/ _interop_require_default(require("../../Colorbar/useColorbar"));
const _Model = /*#__PURE__*/ _interop_require_default(require("../Model"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const PATH_TO_WASM = "/irrenderer.wasm";
function useModel(legacy = false) {
    // bindings -->
    const [irmodel, setIRModel] = (0, _react.useState)(null);
    const [irrenderer, setIRRenderer] = (0, _react.useState)(null);
    const [imageInfo, setImageInfo] = (0, _react.useState)({});
    const [images, setImages] = (0, _react.useState)({});
    const [isReady, setIsReady] = (0, _react.useState)(false);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const [paletteGradient, setPaletteData] = (0, _useColorbar.default)();
    const imageInfoFrame = (0, _react.useMemo)(()=>(0, _utilities.getImageInfoByFrameIndex)(imageInfo), [
        imageInfo
    ]);
    (0, _react.useEffect)(()=>{
        const Model = new _Model.default({
            legacy,
            path_to_wasm: PATH_TO_WASM,
            onImageInfo: setImageInfo,
            onImages: setImages,
            onReady: setIsReady,
            onLoading: setIsLoading,
            onColorbar: setPaletteData
        });
        setIRModel(Model);
        setIRRenderer(Model.irrenderer);
        return ()=>{
            if (irmodel) {
                irmodel.cleanup();
                setIsReady(false);
                setIRModel(null);
            }
        };
    }, []);
    return {
        irmodel,
        irrenderer,
        // image payload -->
        imageInfo,
        imageInfoFrame,
        images,
        // palettes -->
        paletteGradient,
        // flags -->
        isReady,
        isLoading
    };
}
